/**
 * Option blueprint for dropdowns and radio groups.
 * @param {string} id id
 * @param {any} value value
 * @param {string} displayValue display value
 * @param {string} meta information
 * @constructor
 */
const InputOption = function(id, value, displayValue, meta = null) {
  return {
    id,
    value,
    displayValue,
    meta
  };
};

export default InputOption;
